<h1>請求内訳詳細</h1>

<!-- 請求内訳情報 -->
<app-urikakekin-electric-urikakekin-info *ngIf="displayFlgSzme037"
  [urikakekinInfo]="urikakekinInfo"></app-urikakekin-electric-urikakekin-info>

<!-- 請求内訳詳細情報(電気) -->
<mat-card appearance="outlined" mat-card class="cur-card"
  *ngIf="displayFlgSzme037 && urikakekinInfo?.srvClsfyCode === SRV_CLSFY_CODE.ELE">
  <mat-card-header>
    <mat-card-title>請求内訳詳細</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-urikakekin-electric-detail *ngIf="displayFlgSzme037"
      [urikakekinInfo]="urikakekinInfo"
      [prdClsfyDiv]="prdClsfyDiv"
      [conCapKva]="conCapKva"
      [conCapKvaUnit]="conCapKvaUnit"
      >
    </app-urikakekin-electric-detail>
    <app-urikakekin-electric-detail-uchiwake *ngIf="displayFlgSzme037 && displayFlgSzme038"
      [urikakekinInfo]="urikakekinInfo" [electricDetailUchiwake]="electricDetailUchiwake"
      [szme038aResponse]="szme038aResponse" 
      [prdClsfyDiv]="prdClsfyDiv"(clickEvent)="onClick()">
    </app-urikakekin-electric-detail-uchiwake>
  </mat-card-content>
</mat-card>

<!-- 請求内訳詳細情報(ガス) -->
<mat-card appearance="outlined" mat-card class="cur-card"
  *ngIf="displayFlgSzme037 && urikakekinInfo?.srvClsfyCode === SRV_CLSFY_CODE.GAS">
  <mat-card-header>
    <mat-card-title>請求内訳詳細</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-urikakekin-gas-detail *ngIf="displayFlgSzme037" [urikakekinInfo]="urikakekinInfo"  [prdClsfyDiv]="prdClsfyDiv"
      [fixedInfo]="fixedInfo"></app-urikakekin-gas-detail>
    <app-urikakekin-gas-detail-uchiwake *ngIf="displayFlgSzme037 && displayFlgSzme038" [urikakekinInfo]="urikakekinInfo"
      [gasDetailUchiwake]="electricDetailUchiwake" [szme038aResponse]="szme038aResponse"  [prdClsfyDiv]="prdClsfyDiv" (clickEvent)="onClick()">
    </app-urikakekin-gas-detail-uchiwake>
  </mat-card-content>
</mat-card>

<!-- 請求内訳詳細情報(その他) -->
<mat-card appearance="outlined" mat-card class="cur-card"
  *ngIf="displayFlgSzme037 && (urikakekinInfo?.srvClsfyCode === SRV_CLSFY_CODE.TEIGAKU || urikakekinInfo?.srvClsfyCode === SRV_CLSFY_CODE.LEASE)">
  <mat-card-header>
    <mat-card-title>請求内訳詳細</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-urikakekin-teigaku-detail *ngIf="displayFlgSzme037"
      [urikakekinInfo]="urikakekinInfo"  [prdClsfyDiv]="prdClsfyDiv"></app-urikakekin-teigaku-detail>
    <app-urikakekin-teigaku-detail-uchiwake *ngIf="displayFlgSzme037 && displayFlgSzme038"
      [urikakekinInfo]="urikakekinInfo" [teigakuDetailUchiwake]="electricDetailUchiwake"
      [szme038aResponse]="szme038aResponse"
      [prdClsfyDiv]="prdClsfyDiv" (clickEvent)="onClick()">
    </app-urikakekin-teigaku-detail-uchiwake>
  </mat-card-content>
</mat-card>